import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    GROWTH_TASKS_QUERY,
    SINGLE_GROWTH_TASK_QUERY,
    CREATE_GROWTH_TASK_MUTATION,
    UPDATE_GROWTH_TASK_MUTATION,
    UPDATE_GROWTH_TASK_PHASES_MUTATION,
    DELETE_GROWTH_TASK_MUTATION,
    UPDATE_GROWTH_TASK_TAG_MUTATION,
    CONFIRM_GROWTH_TASK_PHASE_MUTATION,
    LOCK_GROWTH_TASK_MUTATION,
    UNLOCK_GROWTH_TASK_MUTATION,
    SPLIT_GROWTH_TASK_MUTATION,
    UPDATE_GROWTH_TASK_SUPPLIER_MUTATION,
    UPDATE_GROWTH_TASK_INVENTORY_MUTATION
} from "@/graphql/growthTasks.js";

const state = {
    growthTasks: []
};

const getters = {};

const mutations = {
    [types.SET_GROWTH_TASKS](state, growthTasks) {
        state.growthTasks = growthTasks;
    },
    [types.SORT_GROWTH_TASKS](state) {
        state.growthTasks.sort(function(a, b) {
            // first sort by greenhouse name, then sort by department name
            return a.node.plant.name.toLowerCase() ==
                b.node.plant.name.toLowerCase()
                ? 0
                : a.node.plant.name.toLowerCase() >
                  b.node.plant.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_GROWTH_TASK](state, growthTask) {
        var index = state.growthTasks.findIndex(function(element) {
            return element.node.id == growthTask.id;
        });

        const node = { node: growthTask };

        if (index > -1) {
            state.growthTasks.splice(index, 1, node);
        } else {
            state.growthTasks.unshift(node);
        }
    },
    [types.DELETE_GROWTH_TASK](state, growthTask) {
        var index = state.growthTasks.find(function(element, index) {
            if (element.id == growthTask.id) {
                return index;
            }
        });

        if (index > -1) {
            state.growthTasks.splice(index, 1);
        }
    }
};

const actions = {
    async fetchGrowthTasks(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GROWTH_TASKS_QUERY,
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // console.log(response);

                    // Option 1: if need extra calculate for each node, use this option
                    // const growthTasks = response.data.growthTasks.edges.map(
                    //     item => {
                    //         return {
                    //             node: item.node
                    //         };
                    //     }
                    // );

                    // Option 2
                    const growthTasks = response.data.tenantGrowthTasks.edges;

                    // set
                    context.commit(types.SET_GROWTH_TASKS, growthTasks);

                    // sort
                    context.commit(types.SORT_GROWTH_TASKS);

                    resolve(growthTasks);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleGrowthTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_GROWTH_TASK_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        id: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(response.data.growthTask)
                    );

                    // // update store
                    // context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    // // sort
                    // context.commit(types.SORT_GROWTH_TASKS);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createGrowthTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_GROWTH_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.createGrowthTask.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    // sort
                    context.commit(types.SORT_GROWTH_TASKS);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGrowthTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GROWTH_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.updateGrowthTask.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    // sort
                    context.commit(types.SORT_GROWTH_TASKS);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGrowthTaskInventory(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GROWTH_TASK_INVENTORY_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.updateGrowthTaskInventory.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    // sort
                    context.commit(types.SORT_GROWTH_TASKS);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGrowthTaskPhases(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GROWTH_TASK_PHASES_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.updateGrowthTaskPhases.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    // sort
                    context.commit(types.SORT_GROWTH_TASKS);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteGrowthTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_GROWTH_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.deleteGrowthTask.growthTask
                        )
                    );

                    // delete
                    context.commit(types.DELETE_GROWTH_TASK, growthTask);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGrowthTaskTag(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GROWTH_TASK_TAG_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.updateGrowthTaskTag.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async confirmGrowthTaskPhase(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CONFIRM_GROWTH_TASK_PHASE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.confirmGrowthTaskPhase.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async lockGrowthTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: LOCK_GROWTH_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(response.data.lockGrowthTask.growthTask)
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async unlockGrowthTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UNLOCK_GROWTH_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.unlockGrowthTask.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async splitGrowthTask(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SPLIT_GROWTH_TASK_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const _response = JSON.parse(
                        JSON.stringify(response.data.splitGrowthTask)
                    );

                    const currentGrowthTask = JSON.parse(
                        JSON.stringify(
                            response.data.splitGrowthTask.currentGrowthTask
                        )
                    );

                    const newGrowthTask = JSON.parse(
                        JSON.stringify(
                            response.data.splitGrowthTask.newGrowthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, currentGrowthTask);
                    context.commit(types.UPSERT_GROWTH_TASK, newGrowthTask);

                    resolve(_response);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGrowthTaskSupplier(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GROWTH_TASK_SUPPLIER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const growthTask = JSON.parse(
                        JSON.stringify(
                            response.data.updateGrowthTaskSupplier.growthTask
                        )
                    );

                    // update store
                    context.commit(types.UPSERT_GROWTH_TASK, growthTask);

                    resolve(growthTask);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
